// =========================
// Testimonial Carousel Init
// =========================

function initTestimonialCarousel(sectionId) {
  const quotes = document.querySelectorAll(`#carousel-container-${sectionId} .carousel-quote`);
  if (!quotes.length) return;

  const dotsContainer = document.getElementById(`dots-${sectionId}`);
  let currentIndex = 0;
  const speed = parseInt(document.getElementById(`carousel-${sectionId}`).dataset.speed) * 1000;

  // Create dots
  if (dotsContainer) {
    dotsContainer.innerHTML = "";
    quotes.forEach((q, i) => {
      const dot = document.createElement("div");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active");
      dotsContainer.appendChild(dot);
    });
  }

  function updateCarousel() {
    quotes.forEach(q => q.classList.remove("active"));
    quotes[currentIndex].classList.add("active");

    if (dotsContainer) {
      const dots = dotsContainer.children;
      [...dots].forEach(d => d.classList.remove("active"));
      dots[currentIndex].classList.add("active");
    }
  }

  updateCarousel();

  setInterval(() => {
    currentIndex = (currentIndex + 1) % quotes.length;
    updateCarousel();
  }, speed);
}

// Init on normal page load
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-testimonial-carousel]").forEach(section => {
    initTestimonialCarousel(section.dataset.sectionId);
  });
});

// Init inside theme editor
document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector("[data-testimonial-carousel]");
  if (section) {
    initTestimonialCarousel(section.dataset.sectionId);
  }
});